<div class="layout-content mt-2">
  <form (ngSubmit)="submit()" [formGroup]="subSectionForm">

    <div class="grid">
      <div class="col-12 my-4 px-6 flex justify-content-center align-items-center">
        <span class="p-float-label w-full">
          <input type="text" pInputText class="w-full" formControlName="KeyHelp" autocomplete="KeyHelp"
            placeholder="{{ 'KEY_SUBSECTION' | translate }}" maxlength="50" />
          <label for="float-input">{{ 'KEY_SUBSECTION' | translate }}*</label>
        </span>
      </div>
    </div>

    <div class="grid">
      <div class="col-3 pl-6 flex justify-content-start align-items-center">
        <p-checkbox formControlName="User" [binary]="true" value="true" label="{{ 'USER' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Technician" [binary]="true" value="true" label="{{ 'TECHNICIAN' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Service" [binary]="true" value="true" label="{{ 'SERVICE' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Guest" [binary]="true" value="true" label="{{ 'GUEST' | translate }}">
        </p-checkbox>
      </div>
    </div>

    <div class="grid">
      <div class="col-3 pl-6 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Thermo" [binary]="true" value="true" label="{{ 'APP_THERMO' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="SetUp" [binary]="true" value="true" label="{{ 'APP_SETUP' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Automation" [binary]="true" value="true"
          label="{{ 'APP_AUTOMATION' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Access" [binary]="true" value="true" label="{{ 'APP_ACCESS' | translate }}">
        </p-checkbox>
      </div>
    </div>
    <div class="grid">
      <div class="col-3 pl-6 flex justify-content-start align-items-center">
        <p-checkbox formControlName="SetUpPro" [binary]="true" value="true" label="{{ 'APP_SETUPPRO' | translate }}">
        </p-checkbox>
      </div>
      <div class="col-3 flex justify-content-start align-items-center">
        <p-checkbox formControlName="Web" [binary]="true" value="true" label="{{ 'APP_WEB' | translate }}">
        </p-checkbox>
      </div>
    </div>

    <div class="grid mt-2">
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleIt"
          autocomplete="TitleIt" placeholder="{{ 'ITALIANO' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'ITALIANO' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleEn"
          autocomplete="TitleEn" placeholder="{{ 'INGLESE' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'INGLESE' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleEs"
          autocomplete="TitleEs" placeholder="{{ 'SPAGNOLO' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'SPAGNOLO' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleDe"
          autocomplete="TitleDe" placeholder="{{ 'TEDESCO' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'TEDESCO' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleFr"
          autocomplete="TitleFr" placeholder="{{ 'FRANCESE' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'FRANCESE' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleNl"
          autocomplete="TitleNl" placeholder="{{ 'OLANDESE' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'OLANDESE' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitlePl"
          autocomplete="TitlePl" placeholder="{{ 'POLACCO' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'POLACCO' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleRu"
          autocomplete="TitleRu" placeholder="{{ 'RUSSO' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'RUSSO' | translate }}*</label>
      </span>
      <span class="p-float-label flex justify-content-center w-full mx-6 my-4">
        <input type="text" pInputText [ngClass]="dynamicInputTextHeight()" class="w-full" formControlName="TitleSk"
          autocomplete="TitleSk" placeholder="{{ 'SLOVENO' | translate }}" maxlength="100" />
        <label for="float-input">{{ 'SLOVENO' | translate }}*</label>
      </span>
    </div>
    <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
      <button type="submit" pButton pRipple [disabled]="!subSectionForm.valid" label="{{ 'CONFIRM' | translate }}"
        class="p-button-primary text-xl font-normal mt-3 sm:mt-0 mr-0 sm:mr-1" [ngClass]="dynamicButtonWidth()">
      </button>
      <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
        class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
      </button>
    </div>
  </form>
</div>